export default __webpack_public_path__ + "static/media/november.c26556aa.png";